import { useEffect } from 'react'

import { form } from '../../../formState'

export function useConnectToAutomatedMessageEnabled() {
  const formApi = form.useFormApi()
  const automatedMessageEnabledField = form.useFormField('automatedMessageEnabled')
  const callbackConfigStatus = form.useFormField('callbackConfigStatus')
  const status = form.useFormField('status')
  const statusValue = status.field.value
  const callbackConfigStatusValue = callbackConfigStatus.field.value

  useEffect(() => {
    const automatedMessageEnabled =
      automatedMessageEnabledField.field.value === 'ON' &&
      statusValue === 'ADVANCED' &&
      callbackConfigStatusValue === 'OFF'

    if (!automatedMessageEnabled) {
      formApi.clearError('automatedMessage')
    }

    formApi.setFieldVisibleState('automatedMessage', automatedMessageEnabled)
    formApi.setFieldVisibleState('automatedMessageVoice', automatedMessageEnabled)
  }, [automatedMessageEnabledField, statusValue, callbackConfigStatusValue, formApi])
}
